HttpEncryptedLogic = xClass("HttpEncryptedLogic")
require("clover/net/SecretKeyConst")

let instance = null
HttpEncryptedLogic.getInstance = function () {
    let self = this
    if (!instance) {
        instance = HttpEncryptedLogic.create()
    }
    return instance
}
const TEST_HTTP = {
    "championInfo": 1,
    "cubeAbTest": 1,
    "shipDetail": 1,
    "login": 1
}
const NO_ENCRYPT_HTTP = {
    "login_getClientConfig": 1
}
HttpEncryptedLogic.prototype.init = function () {
    let self = this
    this.useOld = false //加密但仍使用老数据
    // this.key_str = "examplekey123456"
    // this.iv_str = "iv12345678901234"
    // this.key = aesjs.utils.utf8.toBytes(this.key_str)
    // this.iv = aesjs.utils.utf8.toBytes(this.iv_str)
    this.version = "1"
    this.hasKey = false
}
HttpEncryptedLogic.prototype.ctor = function () {
    let self = this
    this.init()
}
HttpEncryptedLogic.prototype.isSupportEncrypt = function () {
    if (window.HttpEncryptOpen != 1) return false
    if (!this.key || !this.iv) return false
    return true
}

HttpEncryptedLogic.prototype.setSecretKeyMsg = function (key, iv, version) {
    this.key_str = key
    this.iv_str = iv
    this.key = aesjs.utils.utf8.toBytes(key)
    this.iv = aesjs.utils.utf8.toBytes(iv)
    this.version = version + ""
    this.hasKey = true
    console.log("[encrypt] setSecretKeyMsg ", key, iv, version)
}
HttpEncryptedLogic.prototype.setSecretKeyMsgByVersion = function ( version) {
    console.log("[encrypt] setSecretKeyMsgByVersion version ", version)
    if (window.HttpEncryptOpen != 1) return // 开关关闭不进行设置
    console.log("[encrypt] setSecretKeyMsgByVersion SecretKeyConst ", SecretKeyConst)
    let data = SecretKeyConst[version]
    console.log("[encrypt] setSecretKeyMsgByVersion ", data)
    if (!data || !data.key || !data.iv) return
    this.key_str = data.key
    this.iv_str = data.iv
    this.key = aesjs.utils.utf8.toBytes(this.key_str)
    this.iv = aesjs.utils.utf8.toBytes(this.iv_str)
    this.hasKey = true
    this.version = version + ""

    // this.key_str = "examplekey123456"
    // this.iv_str = "iv12345678901234"
    // this.key = aesjs.utils.utf8.toBytes(this.key_str)
    // this.iv = aesjs.utils.utf8.toBytes(this.iv_str)
    // console.log("[encrypt] setSecretKeyMsgByVersion ", key, iv, version)
}
HttpEncryptedLogic.prototype.checkEncrypt = function (data) {
    // console.log("[encrypt] checkEncrypt data", data)
    let self = this
    if (!self.isSupportEncrypt()) {
        return data
    }
    if (!data || !isArray(data) || !data[0] || !data[1]) return data
    try {
        let needEncrypt = true
        for (let i = 0; i < data[1].length; i++) {
            // if (data[1][i].method && TEST_HTTP[data[1][i].method]) {
            //     needEncrypt = true
            // }
            if (data[1][i].method && NO_ENCRYPT_HTTP[data[1][i].method]) {
                needEncrypt = false
            }
        }
        if (!needEncrypt) return data
        data[0].others.enableEncrypt = "1"
        data[2] = {
            wxKeyVersion: self.version,
            encryptData: self.encrypt(JSON.stringify(data[1]))
        }
    } catch (error) {
        DCAssist.dc4Encrypt("encrypt_fail", "", "wrong_logic", error)
    }

    // console.log("[encrypt] checkEncrypt encrypt data", data)
    // let testData = self.decrypt(data[2].encryptData)

    return data
}

HttpEncryptedLogic.prototype.checkDecrypt = function (xhr,target) {
    let self = this
    // console.log("[encrypt] checkDecrypt responseURL", xhr.responseURL)
    // console.log("[encrypt] checkDecrypt response", xhr.response)
    let result = ""
    let newResponse = xhr.response
    if (!self.isSupportEncrypt()) {
        return newResponse
    }
    let reportError = (reson,desc, msg, method, category = "decryptError") => {
        // let errMsg = `desc:${desc}  msg:${msg}`
        let info = {
            desc:desc,
            stack:msg,
            data:xhr.response,
            key: self.key_str,
            iv: self.iv_str
        }
        DCAssist.dc4Encrypt("decrypt_fail", method, reson, info)
        let infostr = JSON.stringify(info)
        window.logCenter && logCenter.error(new Error(`method=${method} reson=${reson} info=${infostr}`), category)
    }
    let method = ""
    try {
        method = self.getDcMethod(target)
        if (!newResponse || newResponse == ""){
            reportError("wrong_logic","newResponse == null ", "",method, "decryptErrorNull")
            return xhr.response
        }
        let getNewResponse = (result) => {
            // console.log("[encrypt] checkDecrypt getNewResponse", result)
            if (isArray(result)) {
                if (result[0] && result[0].others && result[0].others.enableEncrypt == "1" &&
                    result[3] && result[3].encryptData) {
                    // method = self.getDcMethod(result[1])
                    let result1 = result[1] ? JSON.stringify(result[1]) : ""
                    result[3].encryptData = JSON.parse(self.decrypt(result[3].encryptData,method,result1)) //解密赋值新的数据
                    let checkData = (dataA, dataB) => {

                        let getDataByMethod = (list, method) => {
                            for (let i = 0; i < list.length; i++) {
                                if (list[i] && list[i].method == method) {
                                    return list[i]
                                }
                            }
                            return null
                        }
                        if (dataA.length == dataB.length) {
                            for (let i = 0; i < dataA.length; i++) {
                                let conf = dataA[i]
                                // let confB = getDataByMethod(dataB, conf.method)
                                let confB = dataB[i]
                                // console.log("[encrypt] 检查sign", conf.method, conf.sign, confB.sign)
                                if (!confB) {
                                    console.log("[encrypt] 检查sign", conf.method, conf.sign, confB.sign)
                                    reportError("data_different1","解密后method缺失","",method)
                                    return false
                                } else if (conf.sign != confB.sign) {
                                    console.log("[encrypt] 检查sign", conf.method, conf.sign, confB.sign)
                                    reportError("data_different2","解密后sign不一致","",method)
                                    return false
                                }
                            }
                        }else{
                            reportError("data_different3","解密后长短不一致","",method)
                            return false
                        }
                        return true
                    }
                    if (checkData(result[1], result[3].encryptData)){
                        // console.log("[encrypt] checkDecrypt 检测数据一致使用密文数据")
                        result[1] = result[3].encryptData
                    }else{
                        console.error("[encrypt] checkDecrypt 检测数据不一致")
                    }
                    return self.useOld ? xhr.response : JSON.stringify(result)
                } else {
                    return xhr.response
                }
            } else {
                if (!result.encryptData) {
                    return xhr.response
                }
                // method = self.getDcMethod(result)
                result.encryptData = JSON.parse(self.decrypt(result.encryptData,method,JSON.stringify(result))) //解密赋值新的数据
                let checkDataNew = (dataA, dataB)=>{
                    // console.error("[encrypt] checkDataNew",method,dataB)
                    for (const key in dataA) {
                        if (key != "encryptData" &&  dataA[key] && (typeof dataA[key] == "string" || typeof dataA[key] == "number")){
                            // console.log("[encrypt] checkDataNew",key, typeof dataA[key],dataA[key],dataB[key])
                            if (dataA[key] != dataB[key]){
                                console.error("[encrypt] checkDataNew",key,dataA[key],dataB[key])
                                reportError("data_different4","解密后对比数据不一致","",method)
                                return false
                            }
                        }
                    }
                    console.log("[encrypt] checkDataNew 对比解密数据无异常")
                    return true
                }
                checkDataNew(result, result.encryptData)
                // return self.useOld ? xhr.response : JSON.stringify(result)
                return xhr.response
            }
        }


        result = JSON.parse(xhr.response)
        // console.log("[encrypt] checkDecrypt result", result)
        newResponse = getNewResponse(result)
        // 测试错误上报
        // reportError("wrong_logic","描述",newResponse,method)
        // let a = null
        // a.b = 1

    } catch (error) {
        console.error("[encrypt] checkDecrypt error",error)
        reportError("wrong_logic","解密过程代码逻辑错误", "",method)
    }
    // console.log("[encrypt] checkDecrypt newResponse", newResponse)
    // responseNew.push({})
    return newResponse
}
HttpEncryptedLogic.prototype.decrypt = function (data,method,result = "") {
    // data.keyVersion
    if (!data) return
    // console.log("[encrypt] decrypt data", data)
    let decryptData = ""
    try {
        // DCAssist.dc4Encrypt("decrypt_start", method)
        let key = this.key
        let iv = this.iv
     
        // key = aesjs.utils.utf8.toBytes("examplekey123456")
        // iv = aesjs.utils.utf8.toBytes("iv12345678901234")
        decryptData = EncryptedTool.aesDecrypt(data, key, iv)
        // console.log("[encrypt] decrypt decryptData", decryptData)
    } catch (error) {
        console.error("[encrypt] decrypt error",method,error)
        result = result.substring(0, 100)//截取部分字符串 是为了确认请求内容是哪个防止过长后面看不到
        let info = {
            stack:"",
            result:result,
            key: this.key_str,
            iv: this.iv_str,
            data:data,
        }
        DCAssist.dc4Encrypt("decrypt_fail", method, "wrong_logic_decrypt", info)
        let infostr = b64Encode(JSON.stringify(info))
        window.logCenter && logCenter.error(new Error(`method=${method} info=${infostr}`), 'decryptError')

    }
    return decryptData

}
HttpEncryptedLogic.prototype.getDcMethod = function (data) {
    let str = ""
    // cc.log("[encrypt] dc4Encrypt getDcMethod ",data)
    if (isArray(data)) {
        for (let i = 0; i < data.length; i++) {
            if (data[i]){
                str += data[i].method ? data[i].method : data[i] + "&"          
            }
        }
    }else if (data){
        str = data.method ? data.method : data
    }
    if (!str) str = ""
    // console.log("[target] getDcMethod",str)

    return str
}

HttpEncryptedLogic.prototype.encrypt = function (data) {
    if (!data) return
    let encryptData = data
    let method = ""
    try {
        let pData = JSON.parse(data)
        method = this.getDcMethod(pData)
        // DCAssist.dc4Encrypt("encrypt_start", method)
        let key = this.key
        let iv = this.iv
        encryptData = EncryptedTool.aesEncrypt(data, key, iv)

    } catch (error) {
        DCAssist.dc4Encrypt("encrypt_fail", method, "wrong_logic", error)
    }
    return encryptData
}

HttpEncryptedLogic.prototype.decryptTest = function (keyStr, ivStr, data) {
    try {
        let key = aesjs.utils.utf8.toBytes(keyStr)
        let iv = aesjs.utils.utf8.toBytes(ivStr)
        decryptData = EncryptedTool.aesDecrypt(data, key, iv)
        console.log("[encrypt] decrypt decryptTest", decryptData)
    } catch (error) {
        console.error("[encrypt] decrypt error",error)
    }

}
module.exports = HttpEncryptedLogic;